import {Component, Input, OnInit} from "@angular/core";
import {FcmSent} from "../../dto/fcm-sent";
import {CustomersService} from "../../home/services/customers.service";

@Component({
  selector: 'app-customer-fcm-logs',
  templateUrl: './customer-fcm-logs.component.html',
  styleUrls: ['./customer-fcm-logs.component.css']
})
export class CustomerFcmLogsComponent implements OnInit {
  @Input() fcmSents: FcmSent[];

  //logs: CustomerEmailLogDto[];


  constructor(
    public customerService: CustomersService
  ) { }

  ngOnInit() {

  }

}
